import { addFormatToken } from '../format-functions';
import { getDate } from '../utils/date-getters';
addFormatToken('D', ['DD', 2], 'Do', function (date) {
    return getDate(date).toString(10);
});
//# sourceMappingURL=day-of-month.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/node_modules/ngx-bootstrap/bs-moment/units/day-of-month.js
// module id = ../../../../ngx-bootstrap/bs-moment/units/day-of-month.js
// module chunks = vendor